import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/packagingCertification/importer/packagingCertificationImporterActions';

export default importerReducers(actions);
